export * from './accident.model';
